export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname:'div', 
              name: "Colunas Marketing",
              attributes: { class: 'row-full' },
              components: [
                {
                  type: 'columnMarketing1', 
                },
                {
                  type: 'columnImageMarketing1', 
                },
                
              ],
              styles: `
             .row-full{
                display: flex; 
                flex-direction:row; 
                width:100vw; 
             }
             @media (max-width:992px){
              .row-full{
                flex-direction:column;
              }
             }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};